import React from 'react';
import { axiosAuth } from './apiBase';

import { handleResponse, handleError } from './response';
const useGLGroupIncentivesService = () => {
    const getGLGroupIncentives = async () => {
        try {
            const response = await axiosAuth.get(`/api/GLGroupIncentives`);
            return handleResponse(response);
        } catch (error) {
            return handleError(error);
        }
    };
    const addGLGroupIncentives = async (values) => {
        try {
            const response = await axiosAuth.post(`/api/GLGroupIncentives`, values);
            return handleResponse(response);
        } catch (error) {
            return handleError(error);
        }
    };
    const updateGLGroupIncentives = async (id, values) => {
        try {
            const response = await axiosAuth.put(`/api/GLGroupIncentives?Id=${id}`, values);
            return handleResponse(response);
        } catch (error) {
            return handleError(error);
        }
    };

    const softDeleteGLGroupIncentives = async (id) => {
        try {
            const response = await axiosAuth.delete(`/api/GLGroupIncentives/soft-delete?Id=${id}`);
            return handleResponse(response);
        } catch (error) {
            return handleError(error);
        }
    };
    return { getGLGroupIncentives, addGLGroupIncentives, updateGLGroupIncentives, softDeleteGLGroupIncentives };
};

export default useGLGroupIncentivesService;
